export enum ApplicationEnvironments {
  Development = 'Development',
  Testing = 'Testing',
  Production = 'Production',
}

export enum ApplicationProductName {
  HomeImprovementLoan = 'Home Improvement Loan',
  SmallLoanProgram = 'Point-of-Sale',
}

export enum BorrowerFraudErrorMessage {
  Fraud = 'Fraud',
  BankFraud = 'Bank Fraud',
}
